import script from "./CoreAnnualProgramsView.vue?vue&type=script&setup=true&lang=js"
export * from "./CoreAnnualProgramsView.vue?vue&type=script&setup=true&lang=js"

import "./CoreAnnualProgramsView.vue?vue&type=style&index=0&id=a0025b14&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a0025b14"]])

export default __exports__